import { createActions, createState, createReducer } from 'reduxsauce-crud'
import { clone } from 'ramda'

const d = { deep: true }

export const BalanceRedux = createActions(
  {
    // Custom actions
    getMoreRequest: ['params'],
    getMoreSuccess: ['balance'],
    getMoreError: ['error'],
  },
  {
    prefix: 'PARENT_PLATFORM_BALANCE_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = BalanceRedux
export const BalanceTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
  getting: {
    fetching: false,
    error: null,
  },
},
{
  get: true,
})

const getMoreRequest = state => state.merge({ getting: { fetching: true, error: null } }, d)
const getMoreSuccess = (state, { balance }) => {
  let newBalance = clone(state.get.results)
  newBalance = [...newBalance, ...balance]
  return state.merge({ getting: { fetching: false, error: null }, get: { results: balance } }, d)
}
const getMoreError = (state, { error }) => state.merge({ getting: { fetching: false, error } }, d)

export const reducer = createReducer(
  INITIAL_STATE, {
    // custom reducers
    [Types.getMoreRequest]: getMoreRequest,
    [Types.getMoreSuccess]: getMoreSuccess,
    [Types.getMoreError]: getMoreError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPlatform/BalanceRedux.js